export default __webpack_public_path__ + "static/media/7.73c03120.png";